import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getSelectedValue, getSelectedOptions } from './helper';
import Spinner from '../../../../../../../../components/Loaders/Spinner';
import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';

const FieldProvider = ({ providerId, isLoading, modal, refill, onChange }) => {
  const { providers } = useSelector((state) => state.services);

  const selectedValue = useMemo(() => getSelectedValue(providers, providerId), [providerId, providers]);
  const selectOptions = useMemo(() => getSelectedOptions(providers, modal), [modal, providers])

  const onChangeProvider = (selected) => {
    const value = Number(selected.value);
    if (value !== providerId) {
      onChange(value);
    }
  };

  const DropdownIndicator = () => (
    <div className="dropdown__indicator-loader">
      <Spinner />
    </div>
  )

  const selectComponents = {
    IndicatorSeparator: null,
  };

  if (isLoading) {
    selectComponents.DropdownIndicator = DropdownIndicator
  }

  return (
    <FormGroup className="form-group__provider">
      <ControlLabel>Provider</ControlLabel>
      <SelectVirtualized
        components={selectComponents}
        onChange={onChangeProvider}
        isDisabled={isLoading}
        noOptionsMessage={() => 'Provider not found'}
        hideSelectedOptions={false}
        value={selectedValue}
        options={selectOptions}
        name={refill ? 'refill_provider_id' : 'provider'}
        placeholder="Choose provider"
      />
    </FormGroup>
  )
};

FieldProvider.propTypes = {
  providerId: PropTypes.any,
  isLoading: PropTypes.bool,
  modal: PropTypes.object,
  onChange: PropTypes.func,
  refill: PropTypes.bool,
}

export default FieldProvider;
